export const accountActionTypes = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  ACCOUNT_INFO: "ACCOUNT_INFO",
  ACCOUNT_CART: "ACCOUNT_CART",
  TOKEN_EXPIRY: "TOKEN_EXPIRY",
  POKER_PROMOS_SUMMARY: "POKER_PROMOS_SUMMARY",
  ORDER_ID: "ORDER_ID"
};
